<div
  class="note-template product-{{product?.toString().toLowerCase()}}"
  [class.note-readonly]="!isEditable"
>
  <ng-container [ngTemplateOutlet]="template" />

  @if (showAuthor) {
    <div class="text-xs mb-4">
      <span class="text-neutral-700">Created By:</span>
      {{ noteDetail?.userName || noteDetail?.createdBy | userProfileCredentialsByEmail | async }}
      on
      {{ noteDetail?.createdOn | date: 'MM/dd/yyyy hh:mm:ss a' }}
    </div>

    @if (noteDetail?.modifiedBy) {
      <div class="text-xs mb-4">
        <span class="text-neutral-700">Modified By:</span>
        {{ noteDetail?.modifiedBy | userProfileCredentialsByEmail | async }}
        on
        {{ noteDetail?.modifiedOn | date: 'MM/dd/yyyy hh:mm:ss a' }}
      </div>
    }
  }

  <div class="flex justify-end gap-2">
    @if (showCancelButton) {
      <button
        pButton
        type="button"
        class="p-button p-button-secondary"
        [disabled]="isExistingNote && noteForm?.pristine"
        [label]="isExistingNote? 'Discard Changes' : 'Cancel'"
        (click)="cancel.emit()">
      </button>
    }
    @if (showSaveButton) {
      <button
        pButton
        type="button"
        class="p-button-action"
        [disabled]="!(noteForm?.valid && !isLoading) || (isExistingNote && noteForm?.pristine) || isLoading || !isSaveButtonEnabled || !noteForm?.dirty"
        [label]="isExistingNote ? 'Save changes' : 'Save'"
        (click)="save.emit()">
      </button>
    }
  </div>
</div>
